export const categories = [
  'Electronics',
  'Collectibles',
  'Fashion',
  'Home & Garden',
  'Sports',
  'Art',
  'Books',
  'Other'
] as const;